export default __webpack_public_path__ + "static/char-thumb-16-a0c5a470db116fafe055482733e0c907.png";